<script setup>
defineProps({
  visible: { type: Boolean, default: false },
  // Coordinates remain part of the tooltip contract while positioning is owned by the heatmap container.
  // eslint-disable-next-line vue/no-unused-properties
  x: { type: Number, default: 0 },
  // eslint-disable-next-line vue/no-unused-properties
  y: { type: Number, default: 0 },
  value: { type: Number, default: 0 },
});
</script>

<template>
  <div
    v-if="visible"
    class="fixed z-50 rounded bg-n-slate-12 px-2 py-1 text-xs text-white"
  >
    {{ value }}
  </div>
</template>
